import React           from 'react';

import DateRangeReport from 'Manager/components/DateRangeReport';
import VehicleTable    from 'Manager/components/FixedRoutes/VehicleTable';

export default class Vehicles extends DateRangeReport {
    getTitle() : (string|React.ReactNode) {
        const urlSearchParams = new URLSearchParams({
            csv    : '1',
            min_ts : this.state.min_ts.valueOf().toString(),
            max_ts : this.state.max_ts.valueOf().toString()
        });
        return (
            <React.Fragment>
                Vehicles from {this.state.min_ts} to {this.state.max_ts}
                <a key='download' href={`/api/manager/report/fixedroutes/vehicles?${urlSearchParams.toString()}`}><i className="fa fa-download"/></a>
            </React.Fragment>
        );
    }
    getTable() : React.ReactNode {
        const getTablePromiseArgs = ( orderby:string, limit:number, skip:number ) => {
            return [
                '/api/manager/report/fixedroutes/vehicles',
                'GET',
                undefined,
                {
                    min_ts   : this.state.min_ts,
                    max_ts   : this.state.max_ts,
                    orderby,
                    limit,
                    skip
                }
            ];
        };
        return <VehicleTable min_ts={this.state.min_ts} max_ts={this.state.max_ts} getTablePromiseArgs={getTablePromiseArgs}/>;
    }
}
